'use client'

import { algoliaProductObjectId } from '@repo/algolia/config'
import { mapProductToElevarViewItemData } from '@repo/elevar/mapper'
import { Product } from '@repo/shopify/types'
import useIdleObserver from '@repo/ui/hooks/useIdleObserver'
import { FunctionComponent, useRef } from 'react'
import { useTelemetry } from '../../../providers/TelemetryProvider'

interface Props {
  shopifyProduct: Product
}

const ProductTelemetry: FunctionComponent<Props> = ({ shopifyProduct }) => {
  const { trackElevarViewItemEvent, trackAlgoliaViewObjectIDsEvent } = useTelemetry()

  // Track product ID of which event was dispatched, to prevent
  // sending multiple events upon page re-renders (e.g. when selecting
  // a variant which changes the URL search params).
  const dispatchedProductId = useRef<string | null>(null)

  useIdleObserver(
    () => {
      if (shopifyProduct) {
        if (dispatchedProductId.current !== shopifyProduct.id) {
          trackElevarViewItemEvent(mapProductToElevarViewItemData(shopifyProduct))

          trackAlgoliaViewObjectIDsEvent({
            eventName: 'View Product Page',
            objectIDs: [algoliaProductObjectId(shopifyProduct.handle)],
          })
        }

        dispatchedProductId.current = shopifyProduct.id
      }
    },
    {
      timeout: 1000, // Run after 1 sec. if browser does not support idle callbacks
      delay: 1000, // Run action after 1 sec. to ensure dl_user_data event runs first
    },
    [shopifyProduct],
  )

  return null
}

export default ProductTelemetry
